"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCityCenterFlag = function SvgCityCenterFlag(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.995 21.24c-1.444-1.505-5.06-2.595-9.356-2.69a.521.521 0 0 1-.48-.345l-1.806-5.106a.295.295 0 0 1 .207-.382l8.684-2.226c.934-.296 1-1.452.35-1.945L17.13 6.861a1.077 1.077 0 0 1-.321-1.443l1.515-2.549c.435-.794-.262-1.823-1.183-1.61L7.22 3.39c-.195.041-.324-.074-.36-.171-.259-.735-1.051-1.068-1.795-.811a1.408 1.408 0 0 0-.88 1.796l4.904 13.87a.516.516 0 0 1-.427.68c-3.047.397-5.48 1.316-6.604 2.485-.52.543-.174 1.506.546 1.506H21.45c.72 0 1.067-.96.546-1.506Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCityCenterFlag);
var _default = exports["default"] = Memo;